import React, { useState } from 'react';
import {CustomChangeLanguage} from "../../helpers/utils";
import {withTranslation} from "react-i18next";

const LanguageSwitcher = ({t}) => {
    const [open, setOpen] = useState(false);

    const handleMouseLeave = () => {
        setOpen(false);
    };

    const style = {
        position : "absolute",
        inset : "auto auto  0px 0px",
        margin : "0px",
        transform : "translate(0px, -37px)"
    }

    return (
        <div
            className="dropdown"
            onMouseLeave={handleMouseLeave}
        >
            <span
                className={`dropdown-toggle btn btn-sm btn-light mb-0 ${open ? "show" : ""}`}
                role="button"
                onClick={event => setOpen(!open)}
                id="languageSwitcher"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <i className="fas fa-globe me-2"></i> {t('language.switcher')}
            </span>
            <ul
                className={`dropdown-menu min-w-auto ${open ? "show" : ""}`}
                style={open ? style : {}}
                aria-labelledby="languageSwitcher"
            >
                <li>
                    <span className={localStorage.getItem('I18N_LANGUAGE') === "en" ? "dropdown-item me-4 cursor-pointer active" : "dropdown-item me-4 cursor-pointer"}
                          onClick={event => CustomChangeLanguage('en')}
                    ><img className="fa-fw me-2" src="/flags/uk.svg" alt=""/>{t('language.english')}</span>
                </li>
                <li>
                    <span
                        className={localStorage.getItem('I18N_LANGUAGE') === "fr" ? "dropdown-item me-4 cursor-pointer active" : "dropdown-item me-4 cursor-pointer"}
                        onClick={event => CustomChangeLanguage('fr')}
                    ><img className="fa-fw me-2" src="/flags/fr.svg" alt=""/>{t('language.french')}</span>
                </li>
            </ul>
        </div>
    );
};

export default withTranslation()(LanguageSwitcher);
